export { default } from "@casino/external/icons/GenericLike";
